/* eslint-disable no-param-reassign, no-restricted-globals */
import $ from 'jquery';
import stringify from 'json-stringify-pretty-compact';
import select2Installer from 'select2';

select2Installer(document, $);
const scriptTag = document.createElement('SCRIPT');

scriptTag.src = `${process.env.SCRIPT_HOST_BASE_URL}/se-widget.js`;
document.head.appendChild(scriptTag);

$(document).ready(() => {
	const defaultOptions = {
		enabledFilters: [],
		enabledDisplayFeatures: [],
	};
	const arrayTypeProperties = [
		'genders',
		'org_ids',
		'competition_level_ids',
		'program_type_ids',
		'sport_keys',
		'enabledFilters',
		'enabledDisplayFeatures',
	];
	const numberTypeProperties = ['org_ids', 'competition_level_ids', 'program_type_ids', 'per_page', 'affiliation_id'];

	function castAsNumber(value) {
		return isNaN(Number(value)) ? value : Number(value);
	}

	function castAsList(value) {
		if (Array.isArray(value)) {
			return value;
		}

		return value
			.split(',')
			.filter((v) => v)
			.map((v) => v.trim());
	}

	function sanitizeValue(key, value) {
		let rv = value;
		if (arrayTypeProperties.includes(key)) {
			rv = castAsList(value);
		}

		if (numberTypeProperties.includes(key)) {
			rv = Array.isArray(rv) ? rv.map(castAsNumber) : castAsNumber(value);
		}

		return rv;
	}

	function addValue(objMap, key, value) {
		const castedValue = sanitizeValue(key, value);

		if (objMap[key]) {
			if (!Array.isArray(objMap[key])) {
				objMap[key] = [objMap[key]];
			}

			if (Array.isArray(castedValue)) {
				objMap[key].push(...castedValue);
			} else {
				objMap[key].push(castedValue);
			}
		} else {
			objMap[key] = castedValue;
		}
	}

	function getFormData(formEntries) {
		return formEntries.reduce((acc, entry) => {
			const data = {
				...acc,
				params: {
					...(acc.params ?? {}),
				},
			};

			if (entry.name.indexOf('params.') > -1 && entry.value) {
				addValue(data.params, entry.name.replace('params.', ''), entry.value);
			} else if (entry.value) {
				addValue(data, entry.name, entry.value);
			}

			return data;
		}, {});
	}

	function getJsCode(options) {
		const json = stringify(options, {
			indent: 4,
			maxLength: 50,
		});
		const unquoted = json.replace(/"([^"]+)":/g, '$1:');

		return `embedSeWidget(${unquoted});`;
	}

	function getScriptEmbed(options) {
		return `
<script type="text/javascript" src="${process.env.SCRIPT_HOST_BASE_URL}/se-widget.js"></script>

<script type="text/javascript">
${getJsCode(options)}
</script>
`;
	}

	function printEmbedCode(options) {
		$('#result-embed').text(getScriptEmbed(options));
	}

	function renderWidget({ idSelector, clientKey, idForWidget }) {
		const options = {
			...defaultOptions,
			...getFormData($('#generator-form').serializeArray()),
		};

		options.id = idForWidget || options.id;

		if (window[clientKey]) {
			window[clientKey].reset();
			window[clientKey] = null;
		}

		$(`#${idSelector}`).html(`
<div id="${idForWidget || options.id}"></div>
<script type="text/javascript">
window['${clientKey}'] = ${getJsCode(options)}
</script>
`);
	}

	function printIframeCode() {
		renderWidget({
			idSelector: 'hidden-embed',
			clientKey: 'iframeWidget',
			idForWidget: 'iframe-widget',
		});

		setTimeout(() => {
			const htmlStr = document.getElementById('iframe-widget').innerHTML;

			if (htmlStr) {
				$('#result-iframe').text(htmlStr.replace(/id="[a-zA-Z0-9-]+"\s/, ''));
			}
		}, 1500);
	}

	$('#generator-form').on('submit', (e) => {
		e.preventDefault();
		const options = {
			...defaultOptions,
			...getFormData($(e.target).serializeArray()),
		};

		printEmbedCode(options);
		printIframeCode();
		$('.se-generator-embed-wrapper').show();
	});

	$('#test-button').on('click', (e) => {
		e.preventDefault();
		renderWidget({
			idSelector: 'test-container',
			clientKey: 'seClient',
		});

		$('.snippet-generator-widget-testor').show();
	});

  $('#auto-fill-json').on('click', (e) => {
    e.preventDefault();

    $('#test-gtm-json').val(JSON.stringify({ organization: { orgName: 'Test Name', orgID: 12345 }}));
  });

  $('#test-button-with-gtm').on('click', (e) => {
    e.preventDefault();

    const rawJsonStr = $('#test-gtm-json').val();

    if (!rawJsonStr) {
      alert('Please provide a valid GTM JSON');
      return;
    }

    try {
      const jsonObj = JSON.parse(rawJsonStr);

      window.dataLayer = [jsonObj];
    } catch (err) {
      console.warn(err);
      alert('Please provide a valid GTM JSON');
      return;
    }

    renderWidget({
			idSelector: 'test-container',
			clientKey: 'seClient',
		});

		$('.snippet-generator-widget-testor').show();
  });

	$.get(`${process.env.BASE_API_URL ?? ''}/filter-options.php`, {
		field_type: 'sport',
	}).then((data) => {
		const htmlStr = data.map((entry) => `<option value="${entry.natural_key}">${entry.name}</option>`).join('');
		const $elem = $('#sportsKeys');

		$elem.html(htmlStr);
		$elem.select2();
	});
});
